import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { isEmpty } from 'lodash-es';

import getSafeRuleListName from '@/services/tools/getSafeRuleListName/getSafeRuleListName';

import { useContactQueryParams } from './useContactQueryParams';
import { useSelectedEntity } from './useSelectedEntity';

const getStatusRule = (statuses: string[]) => {
    if (isEmpty(statuses)) {
        return null;
    }

    const capitalizedStatuses = statuses?.map((status): string => status.charAt(0).toUpperCase() + status.slice(1));
    return `( status = '${capitalizedStatuses.join("' OR status = '")}' )`;
};

const getSearchRule = (search: string) => {
    if (!search) {
        return null;
    }
    return `(email contains '${search}')`;
};

export const useEntityRuleForFiltration = () => {
    const [entityRule, setEntityRule] = useState('');
    const [filtrationRuleWithQuery, setFiltrationRuleWithQuery] = useState('');
    const { queryStatuses, querySearch } = useContactQueryParams();
    const { listname } = useParams<{ listname: string }>();
    const { selectedEntity, isAllContactsSegment, getDisplayName } = useSelectedEntity();
    const isEntityAList = !!listname;
    const displayName = getDisplayName();

    useEffect(() => {
        const segmentRule = isAllContactsSegment ? null : selectedEntity?.Rule;
        const listRule = `List = '${getSafeRuleListName(listname, true)}'`;
        setEntityRule(isEntityAList ? listRule : segmentRule);
    }, [displayName, selectedEntity]);
    useEffect(() => {
        const ruleComponents = [entityRule, getSearchRule(querySearch), getStatusRule(queryStatuses)];
        setFiltrationRuleWithQuery(ruleComponents.filter(Boolean).join(` AND `));
    }, [queryStatuses, entityRule, querySearch]);

    return {
        entityRule,
        filtrationRuleWithQuery,
        isAllContactsSegment,
    };
};
